// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprRejectAndPay extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.reject_and_pay";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprRejectAndPay {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "Rebutjar i pagar",
                "cs": "Odmítnout a zaplatit",
                "da": "Afvis og betal",
                "de": "Ablehnen und bezahlen",
                "en": "Reject and pay",
                "es": "Rechazar y pagar",
                "eu": "Ukatu eta ordaindu",
                "fi": "Estä ja maksa",
                "fr": "Refuser et payer",
                "gl": "Denegar e pagar",
                "hi": "इनकार और भुगतान करें",
                "hu": "Elutasítás és fizetés",
                "it": "Rifiuta e paga",
                "nl": "Afwijzen en betalen",
                "no": "Avvis og betal",
                "pl": "Odmów i zapłać",
                "pt": "Rejeitar e pagar",
                "pt-BR": "Rejeitar e pagar",
                "ro": "Respinge și plătește",
                "ru": "Отклонить и оплатить",
                "sk": "Odmietnuť a zaplatiť",
                "sv": "Neka och betala",
                "tr": "Reddet ve öde"
            },
            "defecto": "Rechazar y pagar"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
